import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MtnaSectionHeaderModule } from '@mtna/core-angular';

import { RdsNumberToStringPipeModule } from '../core/pipes';
import { RdsPackageBundleSelectionModule } from '../package-bundle-selection/index';
import { RdsPackageFormatSelectionModule } from '../package-format-selection/index';
import { RdsFormatSelectionDialogComponent } from './format-selection-dialog.component';
import { RdsPackageDocumentSelectionModule } from '../package-document-selection';

const COMPONENTS = [RdsFormatSelectionDialogComponent];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatBadgeModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    MtnaSectionHeaderModule,
    RdsNumberToStringPipeModule,
    RdsPackageBundleSelectionModule,
    RdsPackageDocumentSelectionModule,
    RdsPackageFormatSelectionModule,
  ],
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
  entryComponents: [RdsFormatSelectionDialogComponent],
})
export class RdsPackageFormatSelectionDialogModule {}

export * from './format-selection-dialog.component';
